import React, {FC} from 'react';

import {Trans} from '../../../libs/shared/core/src/helpers/internationalization/react';
import {DropdownItemContent} from '../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemContent';
import {DropdownItemIcon} from '../../../libs/shared/ui/src/components/dropdowns/items/dropdownItemIcon';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {useUserTheme} from '../../../libs/shared/ui/src/theme/userThemeProvider';
import {
  useComposeDiscussionOfflinePermission,
  useComposeMessageOfflinePermission,
} from '../../../srcCommon/permissions/useOfflinePermission';
import {useAppSelector} from '../../helpers/appReduxHelpers';
import {getHasComposeChannel} from '../../store/data/channels/channelsSelectors';
import {getHasInternalDiscussions} from '../../store/data/company/companySelectors';
import {PermissionDropdownItem} from './dropdowns/permissionDropdownItem';

/*
 * Props.
 */

interface NewConversationDropdownProps {
  variant: VisualSizesEnum.SMALL | VisualSizesEnum.MEDIUM;
  onComposeMessage: () => void;
  onComposeDiscussion: () => void;
}

/*
 * Component.
 */

export const NewConversationDropdownItems: FC<NewConversationDropdownProps> = (props) => {
  const messageOfflinePermission = useComposeMessageOfflinePermission();
  const discussionOfflinePermission = useComposeDiscussionOfflinePermission();
  const canComposeMessage = useAppSelector((state) => getHasComposeChannel(state, undefined));
  const canComposeDiscussion = useAppSelector(getHasInternalDiscussions);

  const theme = useUserTheme();
  const [iconSize, color] =
    props.variant === VisualSizesEnum.SMALL ? [16, theme.greys.shade80] : [20, theme.greys.shade60];

  return (
    <>
      <PermissionDropdownItem
        onSelect={props.onComposeMessage}
        isDisabled={!canComposeMessage}
        offlinePermission={messageOfflinePermission}
      >
        <DropdownItemIcon iconName="compose" color={color} iconSize={iconSize} label={null} />
        <DropdownItemContent>
          <Trans id="new-conversation-dropdown-message">New message</Trans>
        </DropdownItemContent>
      </PermissionDropdownItem>
      <PermissionDropdownItem
        onSelect={props.onComposeDiscussion}
        isDisabled={!canComposeDiscussion}
        offlinePermission={discussionOfflinePermission}
      >
        <DropdownItemIcon iconName="chat" color={color} iconSize={iconSize} label={null} />
        <DropdownItemContent>
          <Trans id="new-conversation-dropdown-discussion">New discussion</Trans>
        </DropdownItemContent>
      </PermissionDropdownItem>
    </>
  );
};
